// extracted by mini-css-extract-plugin
export default {"blurred":"HeaderTab_blurred__hevxb","alerts":"HeaderTab_alerts__Zsb0B","add":"HeaderTab_add__fu-rS"};